// https://juristr.com/blog/2016/09/ng2-get-window-ref/

import { Injectable } from '@angular/core';

function _window(): Window {
   // return the global native browser window object
   return window;
}

@Injectable()
export class WindowRef {
   get nativeWindow(): any {
      return _window();
   }

   get currentDomain(): string {
       return _window().location.protocol + '//' + _window().location.hostname;
   }
}
